import React from 'react'
import { arrayOf, node, number, shape, string, boolean } from 'prop-types'

import CaptionedMedia from '@/component/Primitive/CaptionedMedia'
import ResponsiveMedia from '@/component/Primitive/ResponsiveMedia'
import ResponsiveImage from '@/component/Primitive/ResponsiveImage'
import SmartLink from '@/component/Primitive/SmartLink'

const InlineImage = (props) => {
  const { caption, height, ratio, width } = props

  return (
    <CaptionedMedia caption={caption}>
      <ResponsiveMedia ratio={ratio || height / width}>
        <InlineImageWrapper {...props} />
      </ResponsiveMedia>
    </CaptionedMedia>
  )
}

const InlineImageWrapper = ({
  destination,
  opensInNewTab,
  width,
  height,
  alt,
  src,
  srcSet,
  sizes
}) => {
  if (destination)
    return (
      <SmartLink
        {...(opensInNewTab
          ? { href: destination, target: '_blank' }
          : { to: destination })}
      >
        <ResponsiveImage
          width={width}
          height={height}
          alt={alt}
          src={src}
          srcSet={srcSet}
          sizes={sizes}
        />
      </SmartLink>
    )
  return (
    <ResponsiveImage
      width={width}
      height={height}
      alt={alt}
      src={src}
      srcSet={srcSet}
      sizes={sizes}
      loading="lazy"
    />
  )
}

InlineImageWrapper.propTypes = {
  alt: string,
  height: number,
  destination: string,
  sizes: arrayOf(string),
  src: string,
  opensInNewTab: boolean,
  srcSet: arrayOf(shape({ width: number.isRequired, src: string.isRequired })),
  width: number
}

InlineImage.propTypes = {
  alt: string,
  caption: node,
  height: number,
  ratio: number,
  destination: string,
  sizes: arrayOf(string),
  src: string,
  opensInNewTab: boolean,
  srcSet: arrayOf(shape({ width: number.isRequired, src: string.isRequired })),
  width: number
}

export default InlineImage
